import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'

import VueRx from 'vue-rx'
import { Observable, Subscription, Subject } from 'rxjs'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChevronRight,
  faChevronLeft,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronRight, faChevronLeft, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// TODO: what's this code ?
Vue.config.productionTip = false
Vue.use(VueRx, { Observable, Subscription, Subject })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
